import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import axios from "axios";
import { removeUser } from "../../store/slice/userSlice";
import { removeConfig } from "../../store/slice/configSlice";
import { SideNav } from "./../../assets/icons/iconshere";
import { defaultLogo } from "../../env";
import { SimApps } from "../../SvgIconsData";
import jwtEncode from "jwt-encode";
import HeaderNavbar from "./HeaderNavbar";

const Header = ({ sideBar, setSideBar }) => {
  const dispatch = useDispatch();
  var location = useLocation();
  var navigate = useNavigate();
  const userData = useSelector((state) => state.userSlice);
  const isLoggedIn = userData.token.length > 0 ? true : false;
  const configData = useSelector((state) => state.configSlice);
  const visibleSections = configData.visibleSections;
  const nameParts = userData.token?.length > 0 ? userData?.user?.name?.split(" ") : "";
  const placeholder =
    nameParts?.length > 0
      ? nameParts?.length >= 2
        ? `${nameParts[0][0]}${nameParts[1][0]}`
        : `${nameParts[0][0]}`
      : "";
  const applications = useSelector((state) => state.applicationSlice).apps;
  var path = location.pathname;
  let MODE = configData.config.MODE;

  const logOut = async () => {
    try {
      await axios.post(
        `${configData.config.UNO_URL}/api/auth/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(removeUser());
      localStorage.clear();
      sessionStorage.clear();
      // window.location.href = `${configData.config.redirectUri}`;
      // navigate("/explore");
      if (configData.visibleSections.includes("explore")) {
        navigate("/explore");
      } else {
        window.location.href = `${configData.config.redirectUri}`;
      }
    }
  };

  const handleClick = (path, state) => {
    return navigate(path, state);
  };

  const handleRegisterUser = () => {
    const payload = {
      origin: window.location.origin,
      redirectUri: window.location.pathname,
    };
    const token = jwtEncode(payload, "");
    return (window.location.href = `${configData.config.redirectUri}?referrer=${token}`);
  };

  const redirectApplication = (link) => {
    if (userData?.token && link) {
      const payload = { token: userData?.token };
      const token = jwtEncode(payload, "");

      if (link.includes("apps.simulanis.io")) {
        const newUrl = `${link}`;
        window.location.href = newUrl;
      } else {
        const newUrl = `${link}?referrer=${token}`;
        window.location.href = newUrl;
      }
    }
  };

  var showSideBar =
    window.location.pathname.startsWith("/explore") ||
    window.location.pathname.startsWith("/home") ||
    window.location.pathname.startsWith("/about-us") ||
    window.location.pathname.startsWith("/contact") ||
    window.location.pathname.startsWith("/course/details/");
  if (sideBar == false) {
    if (showSideBar) setSideBar(true);
    else setSideBar(false);
  }

  const handleClickMyDashboard = () => {
    setSideBar(false);

    if (MODE == "XR") {
      handleClick(`/dashboard/${userData.user.uuid}`, { state: userData.user });
    } else {
      handleClick(`/2d/lms/dashboard/${userData.user.uuid}`, { state: userData.user });
    }
  };

  return (
    <header>
      <>
        <div className="sidetoggle">
          {!showSideBar && (
            <div
              className={sideBar ? "ps-1 activebar sidesvgdiv" : " sidesvgdiv ps-1"}
              onClick={() => setSideBar(!sideBar)}
              style={{ width: "25px", height: "25px" }}
            >
              <SideNav />
            </div>
          )}

          <div className="mainlogo LOGOHERE">
            <img
              src={configData.config.logo || applications.filter((e) => e.uuid === configData.config.applicationId)[0]?.icon}
              onError={(e) => {
                e.target.src = defaultLogo;
                e.onerror = null;
              }}
              referrerPolicy={"no-referrer"}
              alt=""
            />

            <p 
            className={ `${isLoggedIn ? 'cdfdtname' : ''}`} 
            > {configData.config.name || "XR Content Library"} </p>
            {/* <p> XR Content Library </p> */}
          </div>

          {/* <Navbar collapseOnSelect expand="lg" className="header-nav p-0">
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto">
                {visibleSections.includes("home") && (
                  <Nav.Link as={Link} className={path === "/home" ? "active" : ""} to="/home">
                    Home
                  </Nav.Link>
                )}
                {visibleSections.includes("aboutUs") && (
                  <Nav.Link as={Link} className={path === "/about-us" ? "active" : ""} to="about-us">
                    About us
                  </Nav.Link>
                )}
                {visibleSections.includes("explore") && (
                  <Nav.Link as={Link} className={path === "/explore" ? "active" : ""} to="explore">
                    Explore
                  </Nav.Link>
                )}
                {visibleSections.includes("contactUs") && (
                  <Nav.Link as={Link} className={path === "/contact" ? "active" : ""} to="contact">
                    Contact
                  </Nav.Link>
                )}
              </Nav>
            </Navbar.Collapse>
          </Navbar> */}

         <HeaderNavbar visibleSections={visibleSections} isLoggedIn={isLoggedIn}/>

        </div>

        <div className="leftmain">
          {isLoggedIn ? (
            <>
              {path.startsWith("/explore") ||
              path.startsWith("/home") ||
              path.startsWith("/about-us") ||
              path.startsWith("/contact") ||
              path.startsWith("/course/details") ? (
                <div className="d-flex align-items-center justify-content-end log-sub backtodashboard">
                  <button onClick={() => handleClickMyDashboard()}> MY DASHBOARD </button>
                </div>
              ) : null}
              <div className="profile">
                <div className="dropdown profileavatar">
                  <p>{userData?.user?.name || null}</p>
                  <button
                    className="btn btn-secondary dropdown-toggle themetoggle "
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div className="useravatar">
                      {userData?.user?.avatar?.length ? (
                        <img
                          src={userData?.user?.avatar}
                          alt="Profile Image"
                          title={userData?.user?.name || null}
                          className="profilepik"
                          referrerPolicy={"no-referrer"}
                        />
                      ) : (
                        <div className="avatar-placeholder">{placeholder.toUpperCase()}</div>
                      )}
                    </div>
                  </button>
                  <div className="dropdown-menu themehere popupon">
                    <div className="profilemenuhead" tabIndex="0">
                      {userData?.user?.avatar?.length ? (
                        <img
                          src={userData?.user?.avatar}
                          alt="Profile Image"
                          title={userData?.user?.name || null}
                          className="profilepik"
                          referrerPolicy={"no-referrer"}
                        />
                      ) : (
                        <div className="avatar-placeholder">{placeholder.toUpperCase()}</div>
                      )}
                      <div className="profilemenudata">
                        <p>{userData?.user?.name || null}</p>
                        <p>{userData?.user?.email || null}</p>
                      </div>
                    </div>
                    <p className="logoutbtn" onClick={logOut}>
                      Log out
                    </p>
                  </div>
                </div>
                <div className="dropdown profileavatar appnavigator">
                  <button
                    className="btn btn-secondary dropdown-toggle themetoggle "
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <SimApps />
                  </button>

                  <div className="dropdown-menu themehere popupon">
                    <div className="menu-long">
                      <div className={applications.length > 2 ? "menubg extraspace" : "menubg"}>
                        {applications.map((e, i) => {
                          if (e.uuid === configData.config.applicationId) return null;
                          return (
                            <div
                              onClick={() => redirectApplication(e.channel?.origins[0]?.url)}
                              key={e.uuid}
                              className="appshere"
                            >
                              <img
                                src={e.icon || defaultLogo}
                                onError={(e) => {
                                  e.target.src = { defaultLogo };
                                  e.onerror = null;
                                }}
                                alt=""
                                referrerPolicy={"no-referrer"}
                              />
                              <p>{e.name}</p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="d-flex align-items-center justify-content-end log-sub">
              <button onClick={handleRegisterUser}> Login </button>
            </div>
          )}
        </div>
      </>
    </header>
  );
};

export default Header;
